import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, Row, Col } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import '../profile.scss';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { Translate, translate } from 'react-jhipster';
import ComponentDatePicker from 'app/shared/component/ComponentDatePicker';
import moment from 'moment';
import { APP_LOCAL_DATE_FORMAT, APP_LOCAL_DATE_FORMAT_YYYYMMDD, Resources } from 'app/config/constants';
import { updateAttributeWithDataResidential } from '../user.reducer';
import { convertStringToDateAndFormatter } from 'app/shared/util/date-utils';

export interface IModalShareInfoResidentialProps extends StateProps, DispatchProps {
  showModal: boolean;
  closeModal: Function;
  getInfo: Function;
}
export interface IModalShareInfoResidentialState {
  birthday: Date;
  required: boolean;
}
var dob = null;

class ModalShareInfoResidential extends React.Component<IModalShareInfoResidentialProps, IModalShareInfoResidentialState> {
  constructor(props) {
    super(props);
  }

  state: IModalShareInfoResidentialState = {
    birthday: null,
    required: false
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.userProfile !== nextProps.userProfile) {
      const { userProfile } = nextProps;
      if (userProfile && userProfile.attributes) {
        let arrDate = userProfile.attributes.filter(item => item.name == 'dateOfBirth');
        if (arrDate.length > 0 && arrDate[0].value != null) {
          if (arrDate[0].value.includes('/')) {
            this.setState({ birthday: convertStringToDateAndFormatter(arrDate[0].value, 'MM/DD/YYYY') });
          } else {
            let date = moment(arrDate[0].value, 'MM/DD/YYYY');
            this.setState({ birthday: new Date(date.format('DD/MM/YYYY')) });
          }
        }
        this.setState({ birthday: null });
      }
    }
  }
  handleValidSubmit = (event, values) => {
    if (this.state.birthday == null && dob != null) {
      values.dateOfBirth = moment(dob).format(APP_LOCAL_DATE_FORMAT_YYYYMMDD);
    } else if (this.state.birthday != null) {
      values.dateOfBirth = this.state.birthday ? moment(this.state.birthday).format(APP_LOCAL_DATE_FORMAT_YYYYMMDD) : '';
    }
    if (this.state.birthday == null && dob == null) {
      this.setState({ required: true });
      return;
    } else {
      this.setState({ required: false });
    }
    this.props.getInfo(values);
  };

  handleInvalidSubmit = (event, errors, values) => {
    if (errors) {
      window['autoFocus'](errors[0]);
    }
  };

  handleChangeDate = date => {
    this.setState({
      birthday: date
    });
  };
  closeModal = () => {
    this.setState({
      birthday: null
    });
    this.props.closeModal();
  };
  bindingData = type => {
    return this.props.userProfile && this.props.userProfile.attributes
      ? this.props.userProfile.attributes.filter(item => item.name == type)
      : null;
  };

  bindingDataBirthDay = type => {
    if (this.props.userProfile && this.props.userProfile.attributes) {
      let arrDate = this.props.userProfile.attributes.filter(item => item.name == type);
      if (arrDate.length > 0 && arrDate[0].value != null) {
        if (arrDate[0].value.includes('/')) {
          dob = convertStringToDateAndFormatter(arrDate[0].value, 'MM/DD/YYYY');
          return dob;
        } else {
          let date = moment(arrDate[0].value, 'MM/DD/YYYY');
          dob = new Date(date.format('DD/MM/YYYY'));
          return dob;
        }
      }
      return null;
    }
    return null;
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.showModal}
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '80%' }}
        >
          <ModalHeader toggle={this.closeModal} />
          <ModalBody>
            <AvForm onValidSubmit={this.handleValidSubmit} onInvalidSubmit={this.handleInvalidSubmit}>
              {/* <div className="row" style={{ padding: '15px' }}> */}
              <div className="row">
                <div className="col-3">
                  <label style={{ width: '100%' }}>Nguồn xác minh</label>
                </div>
                <div className="col-9">
                  <AvField name="resources" label="" type="select" value="">
                    <option key={Resources[7].key} value={Resources[7].key}>
                      {Resources[6].value}
                    </option>
                  </AvField>
                </div>
              </div>

              {this.bindingData('identity').length > 0 && this.bindingData('identity')[0].value != null ? (
                <div className="row">
                  <div className="col-3">
                    <label style={{ width: '100%' }}>
                      Số CMT <strong style={{ color: '#FF0000' }}>*</strong>
                    </label>
                  </div>
                  <div className="col-9">
                    <AvField
                      name="identity"
                      type="text"
                      value={this.bindingData('identity').length > 0 ? this.bindingData('identity')[0].value : ''}
                      readOnly={true}
                    />
                  </div>
                </div>
              ) : null}

              {this.bindingData('citizenId').length > 0 && this.bindingData('citizenId')[0].value != null ? (
                <div className="row">
                  <div className="col-3">
                    <label style={{ width: '100%' }}>
                      Số CCCD <strong style={{ color: '#FF0000' }}>*</strong>
                    </label>
                  </div>
                  <div className="col-9">
                    <AvField
                      name="citizenId"
                      type="text"
                      value={this.bindingData('citizenId').length > 0 ? this.bindingData('citizenId')[0].value : ''}
                      readOnly={true}
                    />
                  </div>
                </div>
              ) : null}

              <div className="row">
                <div className="col-3">
                  <label style={{ width: '100%' }}>
                    Họ và tên <strong style={{ color: '#FF0000' }}>*</strong>
                  </label>
                </div>
                <div className="col-9">
                  <AvField
                    name="cn"
                    value={this.bindingData('cn').length > 0 ? this.bindingData('cn')[0].value : ''}
                    validate={{
                      required: { value: true, errorMessage: translate('register.messages.validate.fullname.required') },
                      maxLength: { value: 250, errorMessage: 'Họ tên quá dài' }
                    }}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-3">
                  <label style={{ width: '100%' }}>
                    Ngày sinh <strong style={{ color: '#FF0000' }}>*</strong>
                  </label>
                </div>
                <div className="col-9">
                  <ComponentDatePicker
                    name="dateOfBirth"
                    value={
                      this.state.birthday != null
                        ? this.state.birthday
                        : this.bindingDataBirthDay('dateOfBirth') != null
                        ? this.bindingDataBirthDay('dateOfBirth')
                        : null
                    }
                    required={this.state.required}
                    handleChange={this.handleChangeDate}
                    label=""
                    placeHolder="dd/mm/yyyy"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-3" />
                <div className="col-9">
                  <div className="row">
                    <div className="col-3">
                      <Button className="btn-register-white" style={{ marginRight: 'auto' }} onClick={this.closeModal} block>
                        <span>Bỏ qua</span>
                      </Button>
                    </div>
                    <div className="col-3">
                      <Button
                        className="btn-register"
                        style={{ marginRight: 'auto' }}
                        type="submit"
                        // onClick={() => this.setState({ stringType: 'null' })}
                        block
                      >
                        <span>Cập nhật</span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userProfile: storeState.userInfo.userProfile,
  resUpdateAttr: storeState.userInfo.resUpdateAttr
});

const mapDispatchToProps = { updateAttributeWithDataResidential };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalShareInfoResidential);
